import { useState } from 'react'
import cn from 'classnames'

import Cupcake from 'src/icons/cupcake.webp'
import Candy from 'src/icons/candy.webp'
import { TLang } from 'src/constants/langs'
import { ContentSteps } from 'src/lib/useStepFlow'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'

import { CustomButton } from '../../button/CustomButton'

import { texts } from './text-second-step'

import { textBtn } from './mock'

import styles from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const SecondStep = ({ onNext, step, lang }: TProps) => {
    const { header, content } = useLocalizedText<true>(lang, texts)
    const [goodBye, setGoodBye] = useState(false)

    const isMultiLineContent =
        lang === 'fr' ||
        lang === 'el' ||
        lang === 'sl' ||
        lang === 'de' ||
        lang === 'ro'

    const defaultText = textBtn.find((item) => item.lang === 'en')?.text ?? ''

    const getBtnTextByLang = () =>
        textBtn.find((item) => item.lang === lang)?.text || defaultText

    const handleClick = () => {
        setGoodBye(true)
        setTimeout(() => {
            onNext(step)
        }, 300)
    }

    return (
        <div className={styles.root}>
            <div className={styles.text_wrapper}>{header}</div>
            <div
                className={cn(styles.mirror_wrapper, {
                    [styles.hello]: !goodBye,
                    [styles.good_bye]: goodBye,
                })}
                style={{ backgroundImage: `url(${Cupcake})` }}
            >
                <img src={Candy} alt="Candy" className={styles.candy} />
                <div
                    className={cn(styles.container, {
                        [styles[`container--multi_line`]]: isMultiLineContent,
                    })}
                >
                    {content}
                </div>
                <div className={styles.wrapper_button} onClick={handleClick}>
                    <CustomButton
                        textBtn={getBtnTextByLang()}
                        classNames={{
                            textBtn: styles.text_btn,
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
